import React from 'react';
import './Home.css';

function Home() {
  return (
    <main className="home">
      <div className="home-container">
        <div className="home-image-wrapper">
          <img 
            src="/images/dragon.jpg" 
            alt="3D Printing Business" 
            className="home-image"
          />
        </div>
        <div className="home-content">
          <h2 className="home-title">Our Business Model</h2>
          <div className="home-text">
            <p>
              We specialize in transforming digital designs into tangible reality through 
              precision 3D printing technology. Our business model is built on three core 
              pillars: innovation, quality, and accessibility.
            </p>
            <p>
              We offer custom 3D printing services for individuals, businesses, and 
              institutions. Whether you need rapid prototyping for product development, 
              custom parts for manufacturing, or unique creations for personal projects, 
              we deliver high-quality results with attention to detail.
            </p>
            <p>
              Our streamlined process begins with your design file, which we review and 
              optimize for the best printing outcome. We utilize state-of-the-art 3D 
              printing technology to ensure precision and durability. From concept to 
              completion, we work closely with our clients to bring their visions to life.
            </p>
            <p>
              We believe in making 3D printing accessible to everyone. Our transparent 
              pricing model and expert consultation ensure you get the best value for your 
              project. We're committed to sustainability, using eco-friendly materials 
              where possible and minimizing waste in our production process.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Home;

